module.exports = "img/step1.148a54.jpeg";